import React, { useEffect, useState } from "react";
import axios from "axios";
import whatsappLogo from "../images/contact/whatsapp-icon-free-png.png";

const API_ENDPOINT = "https://backend.aktcorp.com/whatsapp/link"; 

const WhatsAppButton = () => {
  const [whatsappUrl, setWhatsappUrl] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchWhatsappUrl = async () => {
      try {
        const response = await axios.get(API_ENDPOINT);

        // Expecting backend response to be like: { link: "https://wa.me/..." }
        if (response.data && response.data.link) {
          setWhatsappUrl(response.data.link);
        } else {
          console.error("Invalid response data:", response.data);
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching WhatsApp link:", err);
        setError(true);
      }
    };

    fetchWhatsappUrl();
  }, []);

  const handleClick = () => {
    if (whatsappUrl) {
      window.open(whatsappUrl, "_blank");
    } else {
      console.error("WhatsApp URL is not available.");
    }
  };

  return (
    <div>
      {whatsappUrl ? (
        <button
          onClick={handleClick}
          className="fixed bottom-0 right-1 md:bottom-0 md:right-7 flex items-center text-white px-1 py-2 md:!py-2 rounded-t-lg transition-all z-50"
        >
          <img
            src={whatsappLogo}
            alt="WhatsApp"
            className="w-6 h-6 md:w-16 md:h-16"
          />
        </button>
      ) : error ? (
        <div className="fixed bottom-0 right-1 md:right-7 bg-[#e91e63] text-white px-3 py-2 rounded-t-lg z-50">
          <span className="text-sm md:text-base font-medium">Not Working</span>
        </div>
      ) : (
        <div className="fixed bottom-0 right-1 md:right-7 bg-[#e91e63] text-white px-3 py-2 rounded-t-lg z-50">
          <span className="text-sm md:text-base font-medium">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default WhatsAppButton;
